import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// if (EnvVariables.production) {
//   enableProdMode();
// }
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => {
    console.error('Error bootstrapping Angular application:', err);
    // Show error in UI if bootstrap fails
    const root = document.querySelector('app-root');
    if (root) {
      root.innerHTML = `
        <div style="padding: 20px; font-family: Arial, sans-serif;">
          <h1>Application Error</h1>
          <p>Failed to bootstrap Angular application. Please check the console for details.</p>
          <pre style="background: #f5f5f5; padding: 10px; overflow: auto;">${err.message || err}</pre>
        </div>
      `;
    }
  });
